/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StateInfo } from '../resource/resource.model';
import { ListResourceState, SingleResourceState } from './state.model';

const selectResource = <T>(stateInfo: StateInfo) =>
  createSelector(
    createFeatureSelector<SingleResourceState>(stateInfo.name),
    (state: SingleResourceState) => <T>getFeatureState<SingleResourceState>(stateInfo, state).resource,
  );

const existResource = <T>(stateInfo: StateInfo) =>
  createSelector(
    createFeatureSelector<SingleResourceState>(stateInfo.name),
    (state: SingleResourceState) => <T>getFeatureState<SingleResourceState>(stateInfo, state).resource.loaded,
  );

const selectListResource = <T>(stateInfo: StateInfo) =>
  createSelector(
    createFeatureSelector<ListResourceState>(stateInfo.name),
    (state: ListResourceState) => <T>getFeatureState<ListResourceState>(stateInfo, state).listResource,
  );

const selectCreatedListItemResource = <T>(stateInfo: StateInfo) =>
  createSelector(
    createFeatureSelector<ListResourceState>(stateInfo.name),
    (state: ListResourceState) => <T>getFeatureState<ListResourceState>(stateInfo, state).createdListItemResource,
  );

function getFeatureState<T>(stateInfo: StateInfo, state: any): T {
  return <T>state.hasOwnProperty(stateInfo.path) ? state[stateInfo.path] : state;
}

export const ResourceSelectors = {
  selectResource,
  existResource,
  selectListResource,
  selectCreatedListItemResource,
};
